// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-content[data-v-960d763e]{overflow:hidden;padding:0}.card-content .content[data-v-960d763e]{padding:1.5em}.card-header[data-v-960d763e]{cursor:pointer}.card-header .icon[data-v-960d763e]{transform:rotate(0deg);transition-duration:.3s}.card-header .icon.rotate[data-v-960d763e]{transform:rotate(180deg);transition-duration:.3s}", ""]);
// Exports
module.exports = exports;
